var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71489 5.07915C8.58356 4.22547 8.78796 3.40733 9.22228 2.74805C7.44979 3.78238 6.31443 5.77321 6.49827 7.97927L7 14H10.0873L8.71489 5.07915Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2851 5.07915C15.4164 4.22548 15.212 3.40733 14.7777 2.74805C16.5502 3.78238 17.6856 5.77321 17.5017 7.97927L17 14H13.9127L15.2851 5.07915Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.395 14L13.8025 4.85107C13.9725 3.74631 13.1178 2.75 12 2.75C10.8822 2.75 10.0275 3.74631 10.1974 4.85107L11.605 14H12.395Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 18H6C5.44772 18 5 17.5523 5 17V15C5 14.4477 5.44772 14 6 14H18C18.5523 14 19 14.4477 19 15V17C19 17.5523 18.5523 18 18 18H17.75V22C17.75 22.4142 17.4142 22.75 17 22.75C16.5858 22.75 16.25 22.4142 16.25 22V18H14.75V20C14.75 20.4142 14.4142 20.75 14 20.75C13.5858 20.75 13.25 20.4142 13.25 20V18H10.75V20C10.75 20.4142 10.4142 20.75 10 20.75C9.58579 20.75 9.25 20.4142 9.25 20V18H7.75V22C7.75 22.4142 7.41421 22.75 7 22.75C6.58579 22.75 6.25 22.4142 6.25 22V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair3);
export default __webpack_public_path__ + "static/media/chair-3.d0a3a6c61c31e2736b55689b85b07987.svg";
export { ForwardRef as ReactComponent };